/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'

import { EuiCallOut, EuiLink } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { ProjectType } from '@modules/ui-types/projects'
import { projectCpsUrl } from '@modules/project-user-lib/urls'

type Props = {
  maxLinkedProjects: number
  currentProjectType: ProjectType
  currentProjectId: string
}

const MaxLinkedProjectsCallout: React.FunctionComponent<Props> = ({
  maxLinkedProjects,
  currentProjectType,
  currentProjectId,
}) => {
  const navigate = useNavigate()

  return (
    <EuiCallOut
      title={
        <FormattedMessage
          id='cps.selectProjects.maxLinkedProjectsReached'
          defaultMessage='Maximum number of linked projects reached'
        />
      }
      color='warning'
      iconType='warning'
    >
      <FormattedMessage
        id='cps.selectProjects.maxLinkedProjectsMessage'
        defaultMessage='You can only link {max} projects to a project for cross-cluster search. To link a new project, unlink an existing project first. {manageLink}'
        values={{
          max: maxLinkedProjects,
          manageLink: (
            <EuiLink onClick={() => navigate(projectCpsUrl(currentProjectType, currentProjectId))}>
              <FormattedMessage
                id='cps.selectProjects.manageLinkedProjects'
                defaultMessage='Manage linked projects'
              />
            </EuiLink>
          ),
        }}
      />
    </EuiCallOut>
  )
}

export default MaxLinkedProjectsCallout
